export const LOADER_STATUS = 'boilderplate/FileGSTR8/LOADER_STATUS';
export const FILE_DATA_GSTR8 = 'boilderplate/FileGSTR8/LOADER_STATUS';
